module.exports = __webpack_public_path__ + "img/xrg.6b8cf605.png";